import React from 'react';
import accessibleSvg from 'utils/accessibleSvg';

export default accessibleSvg(({ children, ...props }) => (
  <svg viewBox="0 0 16 17" {...props}>
    {children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2667 13.9183C10.2667 15.0228 9.37123 15.9183 8.26666 15.9183C7.1621 15.9183 6.26666 15.0228 6.26666 13.9183"
      fill="currentColor"
    />
    <path
      d="M10.2667 13.9183V13.9183C10.2667 15.0228 9.37123 15.9183 8.26666 15.9183C7.1621 15.9183 6.26666 15.0228 6.26666 13.9183"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9333 11.9183V7.58494V7.58498C13.9308 5.21849 12.4578 3.10279 10.2394 2.27896V2.27896C10.0618 1.18875 9.03415 0.448874 7.94393 0.626401C7.09505 0.764629 6.4296 1.43008 6.29137 2.27896L6.29137 2.27896C4.07307 3.10252 2.60085 5.2187 2.60001 7.58495V11.9183C2.60001 13.0228 1.70457 13.9183 0.600006 13.9183H15.9333C14.8288 13.9183 13.9333 13.0228 13.9333 11.9183V11.9183Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
